import { InjectionToken } from '@angular/core';

import { ContainerModes } from '®shared/container-structure/common/container-mode.constant';

export const LAUNCH_MODE = new InjectionToken<string>('app.context.launchMode');

export enum LaunchMode {
  VIEW = 'view',
  VIEW_DRAFT = 'view_draft',
  EDIT = 'edit',
  VIEW_AS_STUDENT = 'view_as_student',
}

export function getValidatedLaunchMode(
  containerMode: ContainerModes,
  isDraft: boolean,
): LaunchMode {
  switch (containerMode) {
    case ContainerModes.Edit:
      return LaunchMode.EDIT;
    case ContainerModes.ViewAsStudent:
      return LaunchMode.VIEW_AS_STUDENT;
    default:
      return isDraft ? LaunchMode.VIEW_DRAFT : LaunchMode.VIEW;
  }
}
